import googleApiService from 'services/googleAPIService';

export default class QuestionResponse {
  public readonly id;
  public submission: string;
  public question: string;
  public response: string;
  public grade: number;
  public completed: boolean;
  public choice: string;
  public num_attempts: number;
  public student_profile_id?: string;
  public feedback?: string;
  public choice_index?: number;
  public audio_url?: string;
  public audio_src?: string;
  public audio_file?: Blob;
  public missed_words?: { word: string; index: number }[];
  public completion_time?: number;

  constructor(
    id: string,
    submission: string,
    question: string,
    response: string,
    grade: number,
    completed: boolean,
    choice: string,
    num_attempts: number = 0,
    student_profile_id?: string,
    feedback?: string,
    choice_index?: number,
    audio_url?: string,
    audio_src?: string,
    missed_words: { word: string; index: number }[] = [],
    completion_time?: number,
    audio_file?: Blob,
  ) {
    this.id = id;
    this.submission = submission;
    this.question = question;
    this.response = response;
    this.grade = grade;
    this.completed = completed;
    this.choice = choice;
    this.num_attempts = num_attempts;
    this.student_profile_id = student_profile_id;
    this.feedback = feedback;
    this.choice_index = choice_index;
    this.audio_url = audio_url;
    this.audio_src = audio_src;
    this.audio_file = audio_file;
    this.missed_words = missed_words;
    this.completion_time = completion_time;
    if (audio_src) return;
    this.getSignedUrls();
  }

  private async getSignedUrls() {
    if (this.audio_src && this.audio_src !== '') return;
    if (this.audio_url && this.audio_url !== '') {
      this.audio_src = await googleApiService.getSignedUrl(this.audio_url);
    }
  }

  static fromQuestionResponse(questionResponse: QuestionResponse) {
    return new QuestionResponse(
      questionResponse.id,
      questionResponse.submission,
      questionResponse.question,
      questionResponse.response,
      questionResponse.grade,
      questionResponse.completed,
      questionResponse.choice,
      questionResponse.num_attempts,
      questionResponse.student_profile_id,
      questionResponse.feedback,
      questionResponse.choice_index,
      questionResponse.audio_url,
      questionResponse.audio_src,
      questionResponse.missed_words,
      questionResponse.completion_time,
      questionResponse.audio_file,
    );
  }

  static fromServerQuestionResponse(
    questionResponse: Record<string, any>,
  ): QuestionResponse {
    return new QuestionResponse(
      questionResponse['id'],
      questionResponse['submission'],
      questionResponse['question'],
      questionResponse['response'],
      questionResponse['grade'],
      questionResponse['completed'],
      questionResponse['choice'],
      questionResponse['num_attempts'],
      questionResponse['student_profile_id'],
      questionResponse['feedback'],
      questionResponse['choice_index'],
      questionResponse['audio_url'],
      questionResponse['audio_src'],
      questionResponse['missed_words'],
      questionResponse['completion_time'],
      questionResponse['audio_file'],
    );
  }

  static generateDefault(): QuestionResponse {
    return new QuestionResponse('', '', '', '', 0, false, '');
  }

  public getId(): string {
    return this.id;
  }

  public toJSON(): Record<string, any> {
    return {
      id: this.id,
      submission: this.submission,
      question: this.question,
      response: this.response,
      grade: this.grade,
      completed: this.completed,
      choice: this.choice,
      feedback: this.feedback,
      student_profile_id: this.student_profile_id,
      num_attempts: this.num_attempts,
      choice_index: this.choice_index,
      audio_url: this.audio_url,
      missed_words: this.missed_words,
      completion_time: this.completion_time,
      audio_file: this.audio_file,
    };
  }
}
